<div class="p-2 flex row justify-between">
    <div class="text-lg font-medium tracking-tight leading-6 truncate">REFERENCE RESULT FOR CDFT
    </div>
    <div>
        <button mat-dialog-close>
            <ng-container [ngTemplateOutlet]="closedIcon"></ng-container>
        </button>
    </div>
</div>

<mat-dialog-content style="color: black;">
    <table>
        <tr>
            <th class="text-center w-48"> REMARKS </th>
            <th class="text-center"> BEFORE GREASING </th>
        </tr>
        <tr>
            <td class="text-center bg-good"> GOOD </td>
            <td> Leak Rate = 0 psi </td>
        </tr>
        <tr>
            <td class="text-center bg-degraded"> DEGRADED </td>
            <td> Leak Rate > 0 psi </td>
        </tr>
        <tr>
            <td class="text-center bg-utt"> UTT </td>
            <td> Unable to Test </td>
        </tr>
        <tr>
            <td class="text-center"> NA </td>
            <td> Not Available </td>
        </tr>

    </table>

    <table class="mt-6">
        <tr>
            <th class="text-center w-48"> REMARKS </th>
            <th class="text-center"> AFTER GREASING </th>
        </tr>
        <tr>
            <td class="text-center bg-good"> GOOD </td>
            <td> Leak Rate = 0 psi </td>
        </tr>
        <tr>
            <td class="text-center bg-degraded"> DEGRADED </td>
            <td> Leak Rate > 0 psi but within allowable limit </td>
        </tr>
        <tr>
            <td rowspan="3" class="text-center bg-failed">FAILED</td>
            <td> XT Valve Leak Rate > 200 psi over 10 mins </td>
        </tr>
        <tr>
            <td> OP/WI : Downhole Plug > 30 psi/30 mins <br> GP/GI : Downhole Plug > 0 psi/30 mins </td>
        </tr>
        <tr>
            <td> SSSV > 660 psi (2-3/8), 440 psi (2-7/8), 290 psi (3-1/2), 170 psi (4-1/2) </td>
        </tr>
        <tr>
            <td class="text-center bg-utt"> UTT </td>
            <td> Unable to Test </td>
        </tr>
        <tr>
            <td class="text-center"> NA </td>
            <td> Not Available </td>
        </tr>

    </table>
</mat-dialog-content>

<ng-template #closedIcon>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
    </svg>
</ng-template>